export default "__VITE_ASSET__549f06a2__"